import { useSearchParams } from '@remix-run/react';

type Modal = 'login' | 'signup';

interface ReturnProps {
  isLoginModalOpen: boolean;
  isSignupModalOpen: boolean;
  handleCloseModal: () => void;
  handleOpenModal: (modal: Modal) => void;
}

const useGlobalModals = (): ReturnProps => {
  const [seachParams, setSearchParams] = useSearchParams();
  const modal = seachParams.get('modal');

  const handleCloseModal = () => {
    seachParams.delete('modal');
    setSearchParams(seachParams, { replace: true });
  };

  const handleOpenModal = (modal: Modal) => {
    seachParams.set('modal', modal);
    setSearchParams(seachParams, { replace: true });
  };

  return {
    isLoginModalOpen: modal === 'login',
    isSignupModalOpen: modal === 'signup',
    handleCloseModal,
    handleOpenModal,
  };
};

export default useGlobalModals;
